import type { FaireProductEntity } from "../../entity_types/product";

export const p_hmh3adjrxb: FaireProductEntity = {
  token: "p_hmh3adjrxb",
  type: "product",
  name: "Smoked Cherry– HI-FI Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/207c5053d055aca0f1ff583af9dc98bc2a4ae45bb84e0e8832ff6b81fe70ab31.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea84261cb7ba378d6fc74e9c73cdb297fcea574fd9bf054d760bc01ef65fa18d.jpeg",
    "https://cdn.faire.com/fastly/a577b014bc7a497349d40258dd0c3450e0ce9c75d1c5b59dd41edd7c7251156d.jpeg",
    "https://cdn.faire.com/fastly/35be466f5d0df869894a305848d54b1e42427ea04aeeb76752a061b1e1fc752d.jpeg",
    "https://cdn.faire.com/fastly/3cf82a11a74816accc6b930a7a79b314390a3625ed5f25c18fab6426871c46cd.jpeg",
    "https://cdn.faire.com/fastly/929198a77c9d5635af5c5ad119ddf1afedb10a0f13e84b8f7a12f29e94f08fb3.jpeg",
  ],
  priceDollars: 19.5,
  description:
    'Inspired by low-lit listening bars and ultra-chic hotel lounges, HI-FI is an olfactive expression of transportive sensory experiences and a meticulous attention to quality and atmosphere.\n\nAn organic take on a gourmand, like biting into a whiskey-tinged maraschino cherry. Fruity and a little earthy.  Marasca cherry, ylang-ylang, and smoked cedar.\n\nEach diffuser contains a 4 fl oz blend of naturally-derived and man-made fragrance oils in a square custom cocoa brown glass bottle with a Vermilion debossed front label and packaged in a premium paper gift box.\n\nLasts approximately 3-4 months.\n\nIncludes a bundle of 9" long naturally-harvested black dyed rattan reeds to absorb and slowly release the fragrance.',
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:56.184Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
